"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Login.scss");
var _downArrow = _interopRequireDefault(require("../../images/downArrow.svg"));
var _upArrow = _interopRequireDefault(require("../../images/up-arrow.svg"));
var _userProfile = _interopRequireDefault(require("../../images/user-profile.svg"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Login = _ref => {
  let {
    login,
    isHidden,
    loginPage,
    Link,
    isAuthenticated,
    userProfile,
    logout,
    authLabels
  } = _ref;
  const [toggle, setToggle] = (0, _react.useState)(false);
  const [showSignout, setShowSignout] = (0, _react.useState)(false);
  const [image, setImage] = (0, _react.useState)(_downArrow.default);
  const ref = (0, _react.useRef)(null);
  const {
    mouse
  } = (0, _useMouse.default)();
  const hangleToggle = () => {
    setToggle(!toggle);
  };
  const {
    welcome: welcomeText,
    login: loginText,
    logout: logoutText
  } = authLabels || {};
  const activateSignOutOnKeyDown = event => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        login.handleLogout();
      }
    }
  };
  const renderListItems = () => {
    if (login && login.content && login.content.list && login.content.list.length) {
      return login.content.list.map((item, index) => {
        if (item.machineName === "sign-out") {
          return /*#__PURE__*/_react.default.createElement("a", {
            tabIndex: mouse ? "" : "0"
            // id={uniqueId("id-")}
            ,
            key: index,
            className: mouse ? "sketchup-login__list-item" : "sketchup-login__list-item tagFocus",
            onClick: () => login.handleLogout(),
            onKeyDown: e => activateSignOutOnKeyDown(e)
          }, item.text);
        } else {
          return /*#__PURE__*/_react.default.createElement("a", {
            tabIndex: mouse ? "" : "0"
            // id={uniqueId("id-")}
            ,
            key: index,
            className: mouse ? "sketchup-login__list-item" : "sketchup-login__list-item tagFocus",
            href: item.url
          }, item.text);
        }
      });
    } else {
      return;
    }
  };
  (0, _react.useEffect)(() => {
    const renderImage = () => {
      const src = toggle ? _upArrow.default : _downArrow.default;
      setImage(src);
    };
    if (login && login.loggedIn) {
      renderImage();
    }
  }, [toggle]);
  const activateClickOnKeyDown = event => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        login.handleLogin();
        //hangleToggle();
      }
    }
  };
  const toggleSignout = () => {
    setShowSignout(!showSignout);
  };
  const handleClickLogout = () => {
    setShowSignout(false);
    logout();
  };
  const handleClickLogin = () => {
    loginPage();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loginPage && !isAuthenticated ? /*#__PURE__*/_react.default.createElement("a", {
    onClick: handleClickLogin,
    className: "login__button",
    style: {
      display: isHidden ? "none" : ""
    }
  }, loginText) : loginPage && isAuthenticated ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: "login"
  }, /*#__PURE__*/_react.default.createElement("p", {
    onClick: () => toggleSignout(),
    className: "login__text"
  }, `${welcomeText}, `, /*#__PURE__*/_react.default.createElement("span", {
    className: "login__user"
  }, ` ${userProfile.firstName}`)), /*#__PURE__*/_react.default.createElement("section", {
    className: "logout",
    style: {
      display: showSignout ? "" : "none"
    }
  }, /*#__PURE__*/_react.default.createElement("a", {
    onClick: () => handleClickLogout(),
    className: "logout__button"
  }, logoutText)))) : /*#__PURE__*/_react.default.createElement("article", {
    className: mouse ? "sketchup-login" : "sketchup-login tagFocus"
    // id={uniqueId("id-")}
    ,
    style: {
      display: isHidden ? "none" : ""
    }
  }, login && login.content && login.content.text && !login.loggedIn && /*#__PURE__*/_react.default.createElement("a", {
    onClick: () => login.handleLogin(),
    className: "sketchup-login__sign-in-text",
    tabIndex: mouse ? "" : "0",
    onKeyDown: e => activateClickOnKeyDown(e),
    "aria-label": `Log in or out` //Todo: update with login state
    ,
    "aria-controls": `login-modal` //Todo: update with login done
    ,
    "aria-expanded": toggle
  }, login.content.text), login && login.loggedIn && /*#__PURE__*/_react.default.createElement("img", {
    tagIndex: mouse ? "" : "0",
    className: mouse ? "sketchup-login__user" : "sketchup-login__user tagFocus",
    alt: "login icon",
    src: userProfile,
    onClick: hangleToggle
  }), login && login.loggedIn && /*#__PURE__*/_react.default.createElement("img", {
    className: "sketchup-login__down-arrow",
    src: image,
    onClick: hangleToggle,
    onKeyDown: e => activateClickOnKeyDown(e),
    alt: "login arrow"
  }), login && login.loggedIn && toggle && /*#__PURE__*/_react.default.createElement("div", {
    className: toggle ? "sketchup-login__list-container active" : "sketchup-login__list-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sketchup-login__email-avatar-name"
  }, (login?.userInformation?.image?.url || login?.userInformation?.image?.src) && /*#__PURE__*/_react.default.createElement("img", {
    className: "sketchup-login__avatar",
    src: login.userInformation.image.url || login.userInformation.image.src,
    alt: "login avatar"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sketchup-login__name-section"
  }, login && login.userInformation && login.userInformation.name && /*#__PURE__*/_react.default.createElement("h3", {
    className: "sketchup-login__user-name"
  }, login.userInformation.name), login && login.userInformation && login.userInformation.email && /*#__PURE__*/_react.default.createElement("p", {
    className: "sketchup-login__user-email"
  }, login.userInformation.email))), renderListItems())));
};
var _default = Login;
exports.default = _default;